"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMinimalDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const Intention_dto_1 = require("./Intention.dto");
class UserMinimalDto {}
exports.UserMinimalDto = UserMinimalDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserMinimalDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserMinimalDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserMinimalDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user shows their gender preferences on their profile.'
}), __metadata("design:type", Boolean)], UserMinimalDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserMinimalDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String],
  enum: enums_1.Gender
}), __metadata("design:type", Array)], UserMinimalDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserMinimalDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserMinimalDto.prototype, "dateOfBirth", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserMinimalDto.prototype, "appVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserMinimalDto.prototype, "publishedAppVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserMinimalDto.prototype, "vibeEmoji", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: Intention_dto_1.IntentionDto
}), __metadata("design:type", Object)], UserMinimalDto.prototype, "intention", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user photo passed Ivy photo verification.'
}), __metadata("design:type", Boolean)], UserMinimalDto.prototype, "isPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'An admin removed this user\'s photo (replaced by a placeholder); the app asks them to upload a new one.'
}), __metadata("design:type", Boolean)], UserMinimalDto.prototype, "isPhotoRejectedByAdmin", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user wants My Places activity pushes.',
  required: false
}), __metadata("design:type", Boolean)], UserMinimalDto.prototype, "myPlacesNotificationsEnabled", void 0);
//# sourceMappingURL=UserMinimal.dto.js.map